import { render } from "./SubPointBuy.vue?vue&type=template&id=6806d4c5&scoped=true"
import script from "./SubPointBuy.vue?vue&type=script&lang=js"
export * from "./SubPointBuy.vue?vue&type=script&lang=js"

import "./SubPointBuy.vue?vue&type=style&index=0&id=6806d4c5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6806d4c5"]])

export default __exports__